// extracted by mini-css-extract-plugin
module.exports = {"label-detail":"label-details_label-detail__2bzo3","label-detail-label":"label-details_label-detail-label__2FtAm","label-detail-content":"label-details_label-detail-content__OXB6V"};